// Dependencies
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { getLoginUrl, getFormationLoginUrl, getLogoutUrl, getPingUrl, getAxiosConfig } from '@/utils/apiUtils'

export default {
  login (login, password) {
    return axios.post(getLoginUrl(),
      {
        username: login,
        password: password
      },
      {
        withCredentials: true
      }
    )
  },

  logout () {
    return axios.get(getLogoutUrl(), { withCredentials: true })
  },

  impersonate (email = null) {
    let activate = email !== null
    let user = activate ? email : '_exit'
    let redirect = activate
      ? { path: '/' }
      : { path: '/admin' }

    axios.get(`${getPingUrl()}?_switch_user=${user}`, getAxiosConfig('impersonate')
    ).then(response => {
      store.dispatch('security/impersonate', {
        activate: activate,
        data: response.data
      }).then(() => {
        router.push(redirect)
      })
    })
  }
}
